<div class="countries-visits-wrapper">
  <div class="country-visit-group-wrapper" *ngFor="let formGroup of visitsArray; index as formGroupIndex">
    <div class="visit-row" [formGroup]="formGroup">
      <div class="left-column">
        <div class="standard-form-field required-field">
          <app-country-select
            class="country-select"
            [fieldControl]="getControl('country', formGroupIndex)"
            [fieldKey]="'visit-country-' + formGroupIndex"
            [isRequired]="true"
            [fieldLabelKey]="'VISIT-COUNTRY'">
          </app-country-select>
        </div>

        <div *ngIf="formGroup.controls.dateEnter as dateEnter" class="standard-form-field required-field">
          <label
            [id]="'country' + formGroupIndex + 'dateEnterLabel'"
            [class.invalid]="dateEnter.touched && dateEnter.invalid">
            {{ 'PERSONAL_DATA_FORM.COUNTRY-VISIT-ENTRY-DATE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              [id]="'country' + formGroupIndex + 'dateEnterInput'"
              matInput
              id="country{{ formGroupIndex }}dateEnter"
              formControlName="dateEnter"
              placeholder="DD.MM.YYYY"
              autocomplete="off"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="dateEnter.touched && dateEnter.invalid ? 'true' : null"
              [attr.aria-describedby]="
                dateEnter.touched && dateEnter.invalid
                  ? 'country' + formGroupIndex + 'dateEnterError country' + formGroupIndex + 'dateEnterTooltip'
                  : 'country' + formGroupIndex + 'dateEnterTooltip'
              "
              [attr.aria-labelledby]="'country' + formGroupIndex + 'dateEnterLabel'" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              matSuffix
              class="info-suffix-icon"
              [text]="'PERSONAL_DATA_FORM.COUNTRY-VISIT-ENTRY-DATE.FORMAT-HINT' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <div
              [id]="'country' + formGroupIndex + 'dateEnterError'"
              *ngIf="dateEnter.touched && dateEnter.invalid"
              class="mat-error">
              {{ dateEnter.errors | errorsFormatingAndTranslate }}
            </div>
          </mat-form-field>
        </div>

        <div *ngIf="formGroup.controls.dateLeave as dateLeave" class="standard-form-field required-field">
          <label
            [id]="'country' + formGroupIndex + 'dateLeaveLabel'"
            [class.invalid]="dateLeave.touched && dateLeave.invalid">
            {{ 'PERSONAL_DATA_FORM.COUNTRY-VISIT-LEAVE-DATE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              [id]="'country' + formGroupIndex + 'dateLeaveInput'"
              matInput
              id="country' + formGroupIndex + 'dateLeave"
              formControlName="dateLeave"
              placeholder="DD.MM.YYYY"
              autocomplete="off"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="dateLeave.touched && dateLeave.invalid ? 'true' : null"
              [attr.aria-describedby]="
                dateLeave.touched && dateLeave.invalid
                  ? 'country' + formGroupIndex + 'dateLeaveError country' + formGroupIndex + 'dateLeaveTooltip'
                  : 'country' + formGroupIndex + 'dateLeaveTooltip'
              "
              [attr.aria-labelledby]="'country' + formGroupIndex + 'dateLeaveLabel'" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              matSuffix
              class="info-suffix-icon"
              [text]="'PERSONAL_DATA_FORM.COUNTRY-VISIT-LEAVE-DATE.FORMAT-HINT' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <div
              *ngIf="dateLeave.touched && dateLeave.invalid"
              [id]="'country' + formGroupIndex + 'dateLeaveError'"
              class="mat-error">
              {{ dateLeave.errors | errorsFormatingAndTranslate }}
            </div>
          </mat-form-field>
        </div>
      </div>
      <div class="right-column">
        <div class="visit-actions">
          <button
            mat-icon-button
            (click)="removeVisit(formGroupIndex)"
            [disabled]="isLoading || visitsArray.length < 2"
            color="warn"
            [attr.aria-label]="
              isLoading || visitsArray.length < 2
                ? ('COMMON.LABEL.DELETE_ELEMENT_UNAVAILABLE' | translate)
                : ('COMMON.LABEL.DELETE_ELEMENT' | translate)
            ">
            <mat-icon
              [class]="isLoading || visitsArray.length < 2 ? 'trash-disabled' : 'trash'"
              svgIcon="trash"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="all-groups-actions">
    <button
      [disabled]="isLoading"
      (click)="addNewVisit()"
      id="addNewTravelButton"
      (keydown.Tab)="lastFieldTabPressed.emit($event)"
      class="standard-form-button add-visit-button">
      {{ 'COUNTRIES_VISITS_FORM.ADD_NEW_TRAVEL' | translate }}
    </button>

    <div *ngIf="isLoading" class="loading-wrapper" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner id="applicantCountriesVisitsSavingLoading" [diameter]="35" [attr.aria-hidden]="true"></mat-spinner>
    </div>

    <div *ngIf="isSaved" class="notification-wrapper saved-notification" aria-live="polite">
      <mat-icon svgIcon="check-outline" id="applicantCountriesVisitsSavingSucccess"></mat-icon>
      <span class="text">{{ 'COUNTRIES_VISITS_FORM.SAVED_SUCCESSFULLY' | translate }} </span>
    </div>

    <div *ngIf="!isSaved && !isLoading" class="notification-wrapper awaiting-notification" aria-live="polite">
      <span class="text">{{ 'COUNTRIES_VISITS_FORM.AWAITING_FOR_ALL_REQUIRED_DATA' | translate }} </span>
    </div>
  </div>
</div>
